import { Toaster } from "sonner";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { DealProtectionDesk } from "../components/DealProtectionDesk";

const LEVEL2 = new Set(["introducer", "custodian", "guarantor"]);

export default function AccountDeals() {
  const { user, api } = useAuth();
  if (user === null) return null; // still checking
  if (!user) return <Navigate to="/login" replace />;
  if (!LEVEL2.has((user?.buyer_category || "").toLowerCase())) {
    return <Navigate to="/account" replace />;
  }
  return (
    <div className="min-h-screen bg-[#050506] text-[#F5F5F0]">
      <Toaster theme="dark" richColors position="top-right" />
      <Header />
      <main className="max-w-6xl mx-auto px-6 md:px-12 pt-28 pb-24">
        <DealProtectionDesk api={api} />
      </main>
      <Footer />
    </div>
  );
}
